<template>
  <div class="bulma-calendar">
    <div class="calendar is-fluid is-borderless">
      <div class="calendar-nav is-light is-border-bottom is-border-top is-border-dashed is-paddingless-left is-paddingless-right">
        <div class="calendar-nav-previous-month">
          <button @click="goToPrevDay" class="button is-ghost is-min-width-0 has-text-grey">
            <i class="fal fa-chevron-left"></i>
          </button>
        </div>
        <div class="is-size-3"><strong>
          <router-link :to="dayLink">{{date | prettyDate}}</router-link>
        </strong></div>
        <div class="calendar-nav-next-month">
          <button @click="goToNextDay" class="button is-ghost is-min-width-0 has-text-grey">
            <i class="fal fa-chevron-right"></i>
          </button>
        </div>
      </div>

      <a v-for="(e, idx) in orderedEventsSlice" :key="e.pk" v-if="['rdvs', 'options'].includes(e._type)" @click="goToEvent(e)"
         class="column is-padding-top-small is-padding-bottom-small"
         :class="{'is-border-bottom': idx < orderedEventsSlice.length - 1}">
        <div v-if="e._type === 'rdvs'">
          <span class="calendar-event is-inline-block is-vcentered is-margin-right-xsmall has-bg-rdv"></span>
          <span class="has-text-grey is-size-6 is-margin-right-xsmal">{{e._date | prettyTime}}</span>
          <span class="is-size-5">&nbsp;<b>{{e.rdv_type}}</b> de {{e.seller_name}} avec {{e.contact_name}}</span>
        </div>
        <div v-else-if="e._type === 'options'">
          <span class="calendar-event is-inline-block is-vcentered is-margin-right-xsmall has-bg-success"></span>
          <span class="has-text-grey is-size-6 is-margin-right-xsmal">{{e._date | prettyTime}}</span>
          <span class="is-size-5">&nbsp;<b>Fin d'option</b> : {{ e.seller_name}} - {{e.lot_ref}}</span>
        </div>
        <!-- <div v-else-if="e._type === 'reminders'">
          <span class="calendar-event is-inline-block is-vcentered is-margin-right-xsmall has-bg-danger"></span>
          <span class="has-text-grey is-size-6 is-margin-right-xsmal">{{e._date | prettyTime}}</span>
          <span class="is-size-5">&nbsp;<b>Rappel</b>: {{e.title}}</span>
        </div> -->
      </a>
      <a v-for="(r, idx) in reminders" :key="r.pk" @click="goToEvent(r)"
         class="column is-padding-top-small is-padding-bottom-small"
         :class="{'is-border-bottom': idx < reminders.length - 1}">
        <div>
          <span class="calendar-event is-inline-block is-vcentered is-margin-right-xsmall has-bg-danger"></span>
          <span class="has-text-grey is-size-6 is-margin-right-xsmal">{{r._date | prettyTime}}</span>
          <span class="calendar-event-label"><strong>Rappel :</strong>&nbsp;{{r.title}}</span>
        </div>
      </a>
      <div v-if="orderedEventsSlice.length === 0 && reminders.length === 0">
        <div class="is-padding is-size-6"><i>Aucun événement</i></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { CalendarDayMx } from '../../../mixins'
  import moment from 'moment'

  export default {
    name: 'SmallCalendarInlineDay',
    mixins: [CalendarDayMx],
    props: {},
    components: {},
    data () {
      return {
        enabledEvents: {
          RDVS: true,
          OPTIONS: true,
          REMINDERS: false,
          USERS: false
        }
      }
    },
    computed: {
      orderedEventsSlice () {
        return this.orderedEvents
          .filter(y => ['rdvs', 'options'].includes(y._type))
          .filter(x => x._type === 'rdvs' ? !x.canceled : true)
          .slice(0, 7)
      },
      dayLink () {
        let date = moment(this.date)
        return {
          name: 'CalendarDayView',
          query: {day: date.date(), month: date.month() + 1, year: date.year()}
        }
      }
    },
    methods: {
      goToEvent (event) {
        let date = moment(event._date)
        this.$router.push({
          name: 'CalendarDayView',
          query: {day: date.date(), month: date.month() + 1, year: date.year()}
        })
      },
      goToPrevDay () {
        let d = this.date.clone()
        d.subtract(1, 'days')
        this.$emit('changeDay', d)
      },
      goToNextDay () {
        let d = this.date.clone()
        d.add(1, 'days')
        this.$emit('changeDay', d)
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/dashboard-admin/SmallCalendarInlineDay.vue